import React from "react";
import PropTypes from "prop-types";

const DaajiMessageHtml = ({ homeProp, eventInfo }) => {
  if (homeProp && eventInfo.length < 1) {
    return null;
  }

  const view = (language) => {
    const link =
      eventInfo?.find((item) => item?.language === language)?.link || "#";
    const a = document.createElement("a");
    a.target = "_blank";
    a.href = link;
    a.click();
  };

  return (
    <div className="daaji_wrrapper shade-bg">
      <div className="container">
        {eventInfo.length > 0 && (
          <div className="daaji_box">
            <h2 className="message-sub-heading">
              <span>HTML Version</span>
            </h2>
            <h6 className="mb-4">
              Choose your Language:
              <br />
            </h6>
            {eventInfo.map((item) => (
              <div className="col-sm-6 col-md-3">
                <div
                  role="button"
                  tabIndex={0}
                  className="message-contents"
                  onClick={() => {
                    view(item.language);
                  }}
                  onKeyDown={() => {
                    view(item.language);
                  }}
                >
                  {item.language}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

DaajiMessageHtml.propTypes = {
  homeProp: PropTypes.bool,
  eventInfo: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      language: PropTypes.string,
    })
  ),
};

DaajiMessageHtml.defaultProps = {
  homeProp: false,
  eventInfo: [],
};

export default DaajiMessageHtml;
